import cookie from 'cookie';

const defaultPageSize = 60;
const sortOptionPVInsertTime = 'insert_time';
const sortOptionInsertTimePriceDesc = 'price_desc';
const sortOptionInsertTimePriceAsc = 'price_asc';
const onSaleParam = 'on_sale=1';
const sortOptions = [
  // {label: 'Sort By', value: sortOptionInsertTime},
  { label: 'New arrivals', shortLabel: 'New arrivals', value: sortOptionPVInsertTime },
  { label: 'Price (highest first)', shortLabel: 'Highest first', value: sortOptionInsertTimePriceDesc },
  { label: 'Price (lowest first)', shortLabel: 'Lowest first', value: sortOptionInsertTimePriceAsc },
];
const defaultSortOption = sortOptions[0];

const getCookie = () => cookie.parse(document.cookie);
const getCookieValue = key => getCookie()[key];
const setCookieValue = (key, value, options) => (document.cookie = cookie.serialize(key, value, options));
const requiresCookieBanner = (isEu, euCookiePolicyAccepted) => isEu && !euCookiePolicyAccepted;
const formatNum = input => parseFloat(input).toFixed(2);
const separateProductDataIntoRows = (products, rowLength) => {
  let groups = [];

  return products.reduce((acc, product, index) => {
    groups.push(product);
    if (groups.length === rowLength || index === products.length - 1) {
      acc.push(groups);
      groups = [];
    }
    return acc;
  }, []);
};

// Products are delivered in multiples of 60 from the backend. Skips are restricted
// to multiples of 60 even if the user manually changes the skip in the URL
const roundDownToMultipleOf60 = skip => {
  if (isNaN(skip)) {
    return 0;
  }
  return skip % 60 === 0 ? skip : roundDownToMultipleOf60(skip - 1);
};

const getNextSkipAmount = (skip, total) => (skip + 60 < total ? skip + 60 : 0);

const replaceSpaceWithDash = str => str.replace(/\s/g, '-');

export {
  defaultPageSize,
  defaultSortOption,
  formatNum,
  getCookie,
  getCookieValue,
  getNextSkipAmount,
  replaceSpaceWithDash,
  requiresCookieBanner,
  roundDownToMultipleOf60,
  separateProductDataIntoRows,
  setCookieValue,
  onSaleParam,
  sortOptions,
  sortOptionPVInsertTime,
  sortOptionInsertTimePriceDesc,
  sortOptionInsertTimePriceAsc,
};
